import { useEffect, useState } from "react";

export function FloatingCTA({ onBook }: { onBook: () => void }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const hero = document.getElementById("top");
    if (!hero || !("IntersectionObserver" in window)) return;
    const obs = new IntersectionObserver(
      ([entry]) => setVisible(!entry.isIntersecting),
      { threshold: 0.15 }
    );
    obs.observe(hero);
    return () => obs.disconnect();
  }, []);

  return (
    <button
      className={`floating-cta${visible ? " visible" : ""}`}
      onClick={onBook}
      aria-label="Book a free intro"
      aria-hidden={!visible}
      tabIndex={visible ? 0 : -1}
    >
      <span className="pulse" />
      Book a free intro
    </button>
  );
}
